<template>
    <v-card class="background-dashboard-memo-card" v-resize="onResize" v-if="isReady">
        <v-card-title v-if="windowSize.x > 1000" class="font-theme d-flex justify-space-between pa-0" style="border-bottom: 1px solid #BCB9B9;">
            <span style="font-weight: 600; font-size: calc(100% + 1.4vw); margin: 3.2% 0% 3.2% 4.8%; line-height: 45px; font-family: 'Sarabun', 'sans-serif';" class="text-center">
                MEMO
            </span>
            <span style="margin: 3.2% 3.2% 3.2% 0%;">
                <v-btn rounded color="#0B68D6" @click="goToDownloadReport()" class="white--text text-center download-report-dashboard-memo" height="53" width="193">
                    Download Report
                </v-btn>
            </span>
        </v-card-title>
        <v-card-title v-else class="font-theme d-flex pa-0" style="border-bottom: 1px solid #BCB9B9;">
            <v-row no-gutters class="font-theme standard-row d-flex justify-space-between" style="padding: 3.8% 3.2% 3.8% 3.2%; line-height: 47px;">
                <v-col cols="11" sm="">
                    <span style="font-weight: 400; font-family: 'Sarabun'; font-size: calc(100% + 1.5vw);">MEMO</span>
                </v-col>
                <v-col cols="1" sm="auto">
                    <v-menu offset-y transition="scroll-y-transition">
                        <template v-slot:activator="{ on }">
                            <v-btn icon v-on="on" color="#414040">
                                <v-icon size="30">mdi-dots-vertical</v-icon>
                            </v-btn>
                        </template>
                        <v-list style="background-color: #414040;">
                            <v-list-item dense @click="goToDownloadReport()">
                                <v-list-item-content>
                                    <v-list-item-title class="font-theme white--text" style="font-size: 16px; line-height: 25px;">Dowload Report</v-list-item-title>
                                </v-list-item-content>
                            </v-list-item>
                        </v-list> 
                    </v-menu>
                </v-col>
            </v-row>
        </v-card-title>
        <v-row no-gutters class="standard-row d-flex justify-end" style="padding: 2.8% 3.2% 2.8% 3.2%;">
            <v-col cols="12" sm="12" md="3" lg="2" class="pr-md-4 pb-4 pb-md-0">
                <v-select :items="processType" v-model="selectedType.value" item-text="text" item-value="value" hide-details outlined height="53" append-icon="mdi-chevron-down" item-color="#D9D9D9" color="black" :menu-props="{ bottom: true, offsetY: true }" @change="changeTypeProcess()" class="font-theme select-dashboard-memo" >
                    <template v-slot:item="data">
                        <v-list-item-content>
                            <v-list-item-title class="font-theme" style="line-height: 30px;">{{ data.item.text }}</v-list-item-title>
                        </v-list-item-content>
                    </template>
                </v-select>
            </v-col>
            <v-col cols="12" sm="12" md="6" lg="4">
                <v-text-field dense outlined hide-details color="black" placeholder="ค้นหาขั้นสูง" height="53"  v-model="holdKeyword" @input="!holdKeyword? checkRowsAndPageBeforeSearch(holdKeyword): ''" @keyup.enter="checkRowsAndPageBeforeSearch(holdKeyword)" class="font-theme search-text-field-dashboard-memo">
                    <template v-slot:append>
                        <v-btn color="#0B68D6" class="white--text font-theme search-dashboard-memo-btn" @click="checkRowsAndPageBeforeSearch(holdKeyword)">
                            Search
                        </v-btn>
                    </template>
                </v-text-field>
            </v-col>
        </v-row>
        <v-row no-gutters class="standard-row font-theme" style="padding: 0% 3.2% 3.8% 3.2%;">
            <v-data-table :headers="headers" range :items="memoTransaction" fixed-header class="elevation-0 data-item-dashboard-memo-table" style="width: 100%;" :options.sync="optionsDataTable" :server-items-length="countMemoTransaction" :footer-props="{'items-per-page-options': [20, 30, 40, 50], 'items-per-page-text':'จำนวนแถวต่อหน้า'}" mobile-breakpoint="850">
                <template v-if="myItem.length < 20" v-slot:body.append="{ isMobile }">
                    <tr v-for="(_, index_tr) in (20 - memoTransaction.length)" :key="`tr__${index_tr}`" v-show="!isMobile">
                        <td v-for="(_, index_td) in 11" :key="`td__${index_td}`"></td>
                    </tr>
                </template>
                <template slot="no-data">
                    <a class="text-center d-flex justify-center black--text" style="font-size: 16px;">
                        ไม่พบข้อมูล
                    </a>
                </template>
                <template v-slot:footer.page-text="items">
                    {{ items.pageStart }} - {{ items.pageStop }} จาก {{ items.itemsLength }} แถว
                </template>
            </v-data-table>
        </v-row>
        <v-card-title class="font-theme d-flex justify-end pa-0" style="border-top: 1px solid #BCB9B9;">
            <span style="font-weight: 400; font-size: 20px; margin: 1.95% 3.2% 1.95% 0%; line-height: 45px;" class="text-center">
                Total : {{ countMemoTransaction }}
            </span>
        </v-card-title>
        <DownloadReportModal />
    </v-card>
</template>

<script>
import { EventBus } from '../EventBus'
import { MainFunction } from '@/functions/mainFunction.js'
import DownloadReportModal from '../components/DownloadReportModal.vue'
export default {
    components: {
        DownloadReportModal
    },
    data: () => ({
        headers: [
            { text: "Memo No."       , value: "memo_no"          , align: "center", sortable: false,  width: 200 },
            { text: "การดำเนินการ"     , value: "process"          , align: "center", sortable: false   ,width: 200},
            { text: "การใช้งบประมาณ"  , value: "in_budget"        , align: "center", sortable: false  ,width: 200},
            { text: "วงเงิน Memo"       , value: "memo_budget"      , align: "center", sortable: false  ,width: 200},
            { text: "PR"                , value: "document_id"      , align: "center", sortable: false    ,width: 200},
            { text: "วันที่เปิดเอกสาร"  , value: "created_at"       , align: "center", sortable: false  ,width: 200},
            { text: "วันที่อัพเดต"     , value: "updated_at"       , align: "center", sortable: false  ,width: 200},
            { text: "วงเงิน PR ใช้ไป"   , value: "total_price"      , align: "center", sortable: false  ,width: 200},
            { text: "ยอดคงเหลือ Memo"  , value: "remaining_budget" , align: "center", sortable: false   ,width: 200},
            { text: "สถานะ PR"          , value: "document_status"  , align: "center", sortable: false,width: 200},
            { text: "Doc No."          , value: "document_id_dwf"  , align: "center", sortable: false,width: 200}
        ],
        myItem: [],
        keyword: '',
        countItem: 0,
        isReady: false,
        holdKeyword: '',
        callApiPending: 0,
        memoTransaction: [],
        windowSize: { x: 0 },
        trigRowPerPage: false,
        countMemoTransaction: 0,
        optionsDataTable: { page: 1, itemsPerPage: 20 },
        processType: [
            {
                text: 'ทั้งหมด',
                value: ''
            },
            {
                text: 'บันทึกงบประมาณ',
                value: 'save'
            },
            {
                text: 'คืนงบประมาณ',
                value: 'refund'
            }
        ],
        selectedType: { value: 'save' },
    }),
    mounted () {
        this.onResize()
        this.getAllMemo()
    },
    computed: {
        selectedBiz() {
            return this.$store.state.confirmSelectedBiz
        }
    },
    watch: {
        "optionsDataTable.page"() {
            this.getAllMemo()
            this.trigRowPerPage = true
        },
        "optionsDataTable.itemsPerPage"() {
            if (!this.trigRowPerPage) {
                this.optionsDataTable.page = 1
                this.getAllMemo()
            }
        },
        "callApiPending"(val) {
            if (val > 0) {
                EventBus.$emit('loadingState', true)
            } else {
                EventBus.$emit('loadingState', false)
            }
        }
    },
    methods: {
        onResize() {
            this.windowSize = { x: window.innerWidth }
        },
        checkRowsAndPageBeforeSearch(params) {
            if (this.keyword === params) {
                return
            }
            this.keyword = params.trim()
            if (this.optionsDataTable.page === 1) {
                this.getAllMemo()
            } else {
                this.optionsDataTable.page = 1
            }
        },
        async getAllMemo() {
            this.callApiPending++
            const countMemoApi= {
                baseURL : this.$api_url,
                url     : `/memo_budget/api/v1/count_memo?keyword=${this.keyword || ''}&process=${this.selectedType.value || ''}&tax_id=${this.selectedBiz.tax_id || ''}`,
                method  : 'GET'
            }
            const searchMemoApi = {
                baseURL : this.$api_url,
                url     : `/memo_budget/api/v1/memo_budget?keyword=${this.keyword || ''}&process=${this.selectedType.value || ''}&tax_id=${this.selectedBiz.tax_id || ''}&offset=${(this.optionsDataTable.page - 1) * this.optionsDataTable.itemsPerPage || 0}&limit=${this.optionsDataTable.itemsPerPage}`,
                method  : 'GET'
            }
            await Promise.all([ this.axios(countMemoApi), this.axios(searchMemoApi) ]).then(values => {
                this.countMemoTransaction = values[0].data.data
                this.memoTransaction      = []
                if (values[1].data.status && values[1].data.data.length) {
                    for (let i = 0; i < values[1].data.data.length; i++) {
                        const tempMemo = {
                            memo_no          : values[1].data.data[i].memo_no     || '-',
                            document_id      : values[1].data.data[i].document_id || '-',
                            in_budget        : values[1].data.data[i].in_budget   || '-',
                            process          : values[1].data.data[i].process     || '-',
                            memo_budget      : MainFunction.addComma(Number(values[1].data.data[i].memo_budget)      || '0'),
                            total_price      : MainFunction.addComma(Number(values[1].data.data[i].total_price)      || '0'),
                            remaining_budget : MainFunction.addComma(Number(values[1].data.data[i].remaining_budget) || '0'),
                            updated_at : MainFunction.fullDateThTime(values[1].data.data[i].updated_at )|| '-',
                            created_at : values[1].data.data[i].transaction_detail.map(detail => MainFunction.fullDateThTime(detail.created_at) || '-'),
                            document_status : values[1].data.data[i].transaction_detail.map(detail => detail.document_status || '-'),
                            document_id_dwf: values[1].data.data[i].document_id_dwf || '-',
                        }
                        this.memoTransaction.push(tempMemo)
                    }
                    $(".data-item-dashboard-memo-table.v-data-table > .v-data-table__wrapper").scrollTop(0)
                }
            }).catch(error => {
                this.memoTransaction      = []
                this.countMemoTransaction = 0
                this.alert('กรุณาลองใหม่อีกครั้ง', 'Fail', 'error')
                console.log(error)
            }).finally(() => {
                this.isReady = true
                this.callApiPending--
                this.trigRowPerPage = false
            })
        },
        goToDownloadReport(){
            const aboutReport = {
                url  : '/report/api/v1/export_reportmemo',
                from : 'dashboard_memo'
            }
            EventBus.$emit('openDownloadReportModal', aboutReport)
        },
        alert(title = '', text = 'Fail', icon = 'info') {
            this.$swal({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 3000,
                icon: icon,
                title: `<b class="alert-success-title">${title}</b>`,
                text:  text,
                showClass: {
                    popup: 'animate-show-card'
                },
                customClass: {
                    container: 'alert-card-block',
                    popup: 'alert-card-success',
                    title: 'alert-title-block',
                    htmlContainer: 'alert-text-box',
                    icon: 'alert-icon'
                }
            })
        },
        changeTypeProcess(){
            if (this.optionsDataTable.page === 1) {
                this.getAllMemo()
            } else {
                this.optionsDataTable.page = 1
            }
        }
    }
}
</script>

<style>
    .background-dashboard-memo-card {
        box-shadow: 0px 4px 50px rgba(0, 0, 0, 0.25) !important;
        margin: 60px 4.51% 56px 4.51% !important;
        border-radius: 23px !important;
    }

    .data-item-dashboard-memo-table tr {
        pointer-events: none;
    }

    .search-dashboard-memo-btn {
        font-size: 15px;
        font-weight: 700;
        border: 1px solid #000000 !important;
        box-shadow: none;
    }

    .search-dashboard-memo-btn.v-btn:not(.v-btn--round).v-size--default {
        height: 53px !important;
        width: 108px;
        border-radius: 0px 15px 15px 0px;
    }

    .search-text-field-dashboard-memo .v-input__control .v-input__slot {
        padding-right: 0px !important;
    }

    .search-text-field-dashboard-memo {
        font-size: 18px !important;
        border-radius: 15px;
    }

    .search-text-field-dashboard-memo.v-text-field--outlined fieldset {
        border-color: black !important;
    }

    .select-dashboard-memo .v-input__control .v-input__slot {
        padding-right: 0px !important;
    }

    .select-dashboard-memo {
        font-size: 18px !important;
        border-radius: 15px;
    }

    .select-dashboard-memo.v-text-field--outlined fieldset {
        border-color: black !important;
    }

    .data-item-dashboard-memo-table thead th {
        height: 49px !important;
        background-color: #333333 !important;
        color: #FFFFFF !important;
        font-size: 20px;
    }

    .data-item-dashboard-memo-table thead th:first-child {
        border-radius: 10px 0 0 0;
    }

    .data-item-dashboard-memo-table thead th:last-child {
        border-radius: 0 10px 0 0;
    }

    .data-item-dashboard-memo-table thead th {
        font-size: 16px !important;
        font-weight: 400;
    }

    .data-item-dashboard-memo-table .v-data-table__wrapper table tbody tr td {
        padding-top: 0px;
        height: 49px !important;
    }

    .data-item-dashboard-memo-table tbody tr td {
        border-left: 1px solid #D8D5D5 !important;
        border-right: 1px solid #D8D5D5 !important;
        border-bottom: 0px !important;
    }

    .data-item-dashboard-memo-table tbody tr td:first-child {
        border-left: 0px !important;
        border-right: 1px solid #D8D5D5 !important;
        border-bottom: 0px !important;
    }

    .data-item-dashboard-memo-table tbody tr td:last-child {
        border-left: 1px solid #D8D5D5 !important;
        border-right: 0px !important;
        border-bottom: 0px !important;
    }

    .data-item-dashboard-memo-table tbody tr:nth-of-type(even) {
        background: #F8F5F5;
    }

    .search-text-field-dashboard-memo .v-input__control .v-input__slot .v-text-field__slot input {
        line-height: 30px;
    }

    .select-dashboard-memo .v-input__control .v-input__slot .v-select__slot .v-select__selections {
        line-height: 30px;
    }

    .data-item-dashboard-memo-table .v-data-table__wrapper table tbody tr td {
        border-left: none !important;
    }

    .data-item-dashboard-memo-table.v-data-table > .v-data-table__wrapper {
        height: calc(100vh - 174px);
        overflow: auto;
        scroll-behavior: smooth;
    }

    .data-item-dashboard-memo-table.v-data-table > .v-data-table__wrapper::-webkit-scrollbar-track {
        border-radius: 10px;
        background-color: transparent !important;
    }

    .data-item-dashboard-memo-table.v-data-table > .v-data-table__wrapper::-webkit-scrollbar {
        width: 8px;
        height: 8px;
        background-color: transparent !important;
    }

    .data-item-dashboard-memo-table.v-data-table > .v-data-table__wrapper::-webkit-scrollbar-thumb {
        border-radius: 10px;
        background-color: #7673735e;
    }

    .download-report-dashboard-memo {
        font-weight: 700;
        font-size: 15px;
        border: 1px solid #000000 !important;
        border-radius: 20px;
    }
  
    .data-item-dashboard-memo-table .v-data-table__wrapper > table thead th:first-child {
        left: 0;
        z-index: 4; /* เพิ่มระดับให้สูงขึ้นเพื่อให้แน่ใจว่าอยู่ด้านหน้า */
    }

    .data-item-dashboard-memo-table .v-data-table__wrapper > table tbody tr:nth-of-type(even) td:first-child {
        position: sticky;
        border-top: 0px solid #D8D5D5 !important;
        border-left: 1px solid #D8D5D5 !important;
        left: 0;
        z-index: 2; /* ปรับระดับให้สูงขึ้น */
        background-color: #F8F5F5;
    }

    .data-item-dashboard-memo-table .v-data-table__wrapper > table tbody tr:nth-of-type(odd) td:first-child {
        position: sticky;
        border-top: 0px solid #D8D5D5 !important;
        border-left: 1px solid #D8D5D5 !important;
        left: 0;
        z-index: 2; /* ปรับระดับให้สูงขึ้น */
        background-color: #FFFFFF;
    }
    @media only screen and (max-width: 849px) {

        .data-item-dashboard-memo-table tbody tr td:first-child {
            border-top: 1px solid #D8D5D5 !important;
            border-left: 1px solid #D8D5D5 !important;
        }

        .data-item-dashboard-memo-table tbody tr td:last-child {
            border-right: 1px solid #D8D5D5 !important;
            border-bottom: 1px solid #D8D5D5 !important;
        }

        .data-item-dashboard-memo-table .v-data-table__wrapper table tbody .v-data-table__empty-wrapper td {
            width: 100vw;
            border-right: none !important;
            border-bottom: none !important;
        }
    }
</style>